import React from 'react'
import { Scrollbar as SB } from 'react-scrollbars-custom'

const Scrollbar = ({ children, onScroll, scrollRef }) => (
  <SB noScrollX trackClickBehavior="jump" onScroll={onScroll} ref={scrollRef}>
    {children}
  </SB>
)
export default Scrollbar
